<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Model'|translate}}
          </v-card-title>
          <v-card-text>
              <span class="caption">{{'Target Equipment'|translate}}</span>
              <v-text-field :label="'Facility Name'|translate" v-model="activeItem.facility_name" disabled></v-text-field>
              <equipment-selector v-model="activeItem.equipment_name"></equipment-selector>
              <v-divider></v-divider>
              <span class="caption">{{'Model Selection'|translate}}</span>

              <v-select v-model="activeItem.model_type" :items="['anomaly', 'supervised', 'power','cooling load']" :label="'Model Type'|translate">
              </v-select>

              <v-select v-model="activeItem.model_name" :items="availableModelName" :label="'Model Name'|translate"></v-select>

              <v-checkbox :label="'Active'|translate" v-model="activeItem.model_active"></v-checkbox>
              <v-text-field :label="'Topic'|translate" v-model="activeItem.topic"></v-text-field>


              <template v-if="activeItem.model_type=='supervised'">
                  <span class="caption">{{'Model Message'|translate}}</span>
                  <code class="pa-4">
                      {{activeItem.result_meta}}
                  </code>
                  <v-text-field :label="'Title'|translate" v-model="activeItem.title"></v-text-field>
                  <v-text-field :label="'Description'|translate" v-model="activeItem.desc"></v-text-field>
                  <v-text-field :label="'Severity'|translate" v-model="activeItem.severity"></v-text-field>
                  <v-text-field :label="'Relevant Variables'|translate" v-model="activeItem.relevant_variables"></v-text-field>
                  <v-text-field :label="'Recommended Actions'|translate" v-model="activeItem.recommended_actions"></v-text-field>
              </template>
              <span class="caption">{{'Training Data Date Range'|translate}}</span>
              <template v-if="activeItem.model_type=='cooling load'">
                  <span class="caption">Cooling Load Prediction Config</span>
                  <v-text-field label="Cooling Load Equipment Name" v-model="coolingLoadItem.coolingLoadEquipmentName"></v-text-field>
                  <v-text-field label="Cooling Load Sensor Name" v-model="coolingLoadItem.coolingLoadSensorName"></v-text-field>
                  <v-text-field label="Outdoor Air Temperature Equipment Name" v-model="coolingLoadItem.oatEquipmentName"></v-text-field>
                  <v-text-field label="Outdoor Air Temperature Sensor Name" v-model="coolingLoadItem.oatSensorName"></v-text-field>
                  <v-text-field label="Cooling Load Unit" v-model="coolingLoadItem.coolingLoadUnit"></v-text-field>
                  <v-text-field label="Result Name" v-model="coolingLoadItem.resultName"></v-text-field>
              </template>
              <date-range-selector v-model="dateRange"></date-range-selector>

          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord();dialog=false;" :disabled="!$can('update', 'Points')">{{'Save'|translate}}</v-btn>
              <v-btn @click="initializeVar();dialog=false">{{'Cancel'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import EquipmentSelector from '../EquipmentSelector'
  import {putModel} from '../../helper'
  import DateRangeSelector from '../DateRangeSelector'

  export default {
    components: { DateRangeSelector, EquipmentSelector },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    computed: {
      availableModelName () {
        if (this.activeItem.model_type=='supervised'){
          if (this.$store.getters.chillerType == 'generic water-cooled') {
            return [
              'Reduced Condenser Water Flow',
              'Condenser Fouling',
              'Non-Condensable in Refrigerant',
              'High Oil Temperature'
            ]
          } else if (this.$store.getters.chillerType == 'air-cooled 2 circuits') {
            return [
              'Air Cooled Winding Temp High Ckt2',
              'Air Cooled Winding Temp High Ckt1',
              'Air Cooled Condenser Cleaning Required',
              'Air Cooled Non Condensable in Refrigerant Ckt1',
              'Air Cooled Non Condensable in Refrigerant Ckt2'
            ]
          }
        } else if (this.activeItem.model_type=='anomaly') {
          return ['anomaly']
        } else if (this.activeItem.model_type=='power') {
          return ['regression', 'gradient boosted trees', 'neural network']
        } else if (this.activeItem.model_type=='cooling load') {
          return ['boosted tree regression']
        } else {
          return ['please select a model type first']
        }
      },
      modelMeta () {
        if (this.activeItem.model_type=='cooling load'){
          return {
            'cooling_load_equipment_name': this.coolingLoadItem.coolingLoadEquipmentName,
            'cooling_load_sensor_name': this.coolingLoadItem.coolingLoadSensorName,
            'oat_equipment_name': this.coolingLoadItem.oatEquipmentName,
            'oat_sensor_name': this.coolingLoadItem.oatSensorName,
            'cooling_load_unit': this.coolingLoadItem.coolingLoadUnit,
            'result_name': this.coolingLoadItem.resultName
          }
        } else{
          return {}
        }
      }
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
          this.dateRange = {
            start: this.activeItem.model_date_from,
            end: this.activeItem.model_date_to
          }
          if (this.activeItem.model_type=='cooling load' && this.activeItem.model_meta.cooling_load_sensor_name){
            this.coolingLoadItem.coolingLoadEquipmentName = this.activeItem.model_meta.cooling_load_equipment_name
            this.coolingLoadItem.coolingLoadSensorName = this.activeItem.model_meta.cooling_load_sensor_name
            this.coolingLoadItem.oatEquipmentName = this.activeItem.model_meta.oat_equipment_name
            this.coolingLoadItem.oatSensorName = this.activeItem.model_meta.oat_sensor_name
            this.coolingLoadItem.coolingLoadUnit = this.activeItem.model_meta.cooling_load_unit
            this.coolingLoadItem.resultName = this.activeItem.model_meta['result_name']?this.activeItem.model_meta['result_name']:'cooling_load'
          }

        }
      },
      value () {
        if (!this.activeItem.model_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dateRange: null,
        dialog: false,
        coolingLoadItem: {
          coolingLoadEquipmentName: '',
          coolingLoadSensorName: '',
          oatEquipmentName: '',
          oatSensorName: '',
          coolingLoadUnit: 'kW',
          resultName: 'cooling load'
        },
        activeItem: {
            'model_id': null,
            'model_type': '',
            'model_name': '',
            'model_status': 'pending',
            'model_active': false,
            'title': '',
            'topic': 'default',
            'desc': '',
            'severity': '',
            'relevant_variables': '',
            'recommended_actions': '',
            'on': true,
            'equipment_name': '',
            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
            'date_range': null
        } ,

      }

    },
    mounted() {
      this.dialog = false
    },
    methods: {
      initializeVar() {
        this.activeItem = {
          'model_id': null,
            'model_type': '',
            'model_name': '',
            'model_status': 'pending',
            'model_active': false,
            'title': '',
            'desc': '',
            'topic': 'default',
            'severity': '',
            'relevant_variables': '',
            'recommended_actions': '',
            'on': true,
            'equipment_name': '',
            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
            'model_date_from': null,
            'model_date_to': null
          }
      },
      addRecord () {
        putModel(
          {
            'model_id': this.activeItem.model_id,
            'model_type': this.activeItem.model_type,
            'model_name': this.activeItem.model_name,
            'model_status': this.activeItem.model_status,
            'model_active': this.activeItem.model_active,
            'title': this.activeItem.title,
            'topic': this.activeItem.topic,
            'desc': this.activeItem.desc,
            'severity': this.activeItem.severity,
            'relevant_variables': this.activeItem.relevant_variables,
            'recommended_actions': this.activeItem.recommended_actions,
            'on': this.activeItem.on,
            'equipment_name': this.activeItem.equipment_name,
            'facility_name': this.activeItem.facility_name,
            'model_date_from': this.dateRange.start,
            'model_date_to': this.dateRange.end,
            'model_meta': this.modelMeta // computed points for cooling load model type
          }
        )
      }
    },
    name: 'ModelRecordDialog'
  }
</script>

<style scoped>

</style>
